import forgotPasswordImage from './Assets/forgot-pass-img.webp';
import logo from '../../Assets/Images/logo.svg';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { ForgotPasswordForm } from '../../Components/ForgotPasswordForm/ForgotPasswordForm';
import { useState } from 'react';
import { Icons } from '../../Components/Icons/Icons';
import { Button } from '../../Components/Button/Button';
import { Link } from 'react-router-dom';
import { auth } from '../../api/auth';
import { useAlert } from '../../contexts/AlertContext';
import { useLoader } from '../../contexts/LoaderContext';

export const ForgotPassword = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const { width } = useWindowDimensions();
  const { showAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();

  const handleSubmit = async (values: { email: string }) => {
    showLoader();
    try {
      await auth.forgotPassword(values);
      setIsSuccess(true);
    } catch (error: any) {
      showAlert(error.message || 'Failed to reset password', 'error');
    } finally {
      hideLoader();
    }
  };

  return (
    <main className="forgot-password">
      {width > 768 && (
        <img src={forgotPasswordImage} alt="abstract background" className="bg-image" />
      )}
      <section className="content">
        {isSuccess ? (
          <>
            {Icons.Success}
            <h1>Password reset</h1>
            <p>Your password has been successfully reset. Click below to sign in.</p>
            <Button variant="link" to="/signin">
              Go to Sign in
            </Button>
          </>
        ) : (
          <>
            <img src={logo} alt="logo" className="logo" />
            <h1>Forgot Your Password?</h1>
            <p>Enter your email address, and we'll send you instructions to reset your password.</p>

            <ForgotPasswordForm onSubmit={handleSubmit} />
            <Link className="back-to" to="/signin">
              Back to Sign in
            </Link>
          </>
        )}
      </section>
    </main>
  );
};
